import prepareTranslate from '@/helpers/dictionary';
import PropTypes from 'prop-types';
import SectionView from '@/components/SectionView';
import Modal from '@/components/DetailsModal';
import { formatDateToString } from '@/helpers/string';
import DownloadFile from '@/components/DownloadFile';

const ViewAdditionalFee = (props) => {
  const {
    fee,
    open,
    close,
    opened,
  } = props;

  const t = prepareTranslate();

  const detailsLines = [
    {
      title: t('components.editAdditionalFee.type'),
      value: fee?.type,
    },
    {
      title: t('components.editAdditionalFee.sum'),
      value: fee?.value,
    },
    {
      title: t('components.editAdditionalFee.date'),
      value: formatDateToString(fee?.date),
    },
    {
      title: t('components.editAdditionalFee.comments'),
      value: fee?.comments,
    },
    {
      title: t('components.editAdditionalFee.isPaid'),
      value: fee?.isPaid ? t('global.yes') : t('global.no'),
    },
    {
      title: t('components.editAdditionalFee.payDate'),
      value: formatDateToString(fee?.payDate),
    },
  ];

  return (
        <Modal
            open={open}
            close={close}
            opened={opened}
            label={t('components.viewAgentAdditionalFees.modalTitle')}
        >
          <SectionView lines={detailsLines} />
          {fee?.files?.map((file, index) => (
              <DownloadFile key={index} file={file} />
          ))}
        </Modal>

  );
};

ViewAdditionalFee.propTypes = {
  fee: PropTypes.object,
  open: PropTypes.func,
  close: PropTypes.func,
  opened: PropTypes.bool,

};

export default ViewAdditionalFee;
